import Cookies from "js-cookie";
import { ICookiePreferences } from "../gtm/ICookiePreferences";

export class CookieService {
	private Cookies = Cookies;
	private _cookieName: string;
	private _cookieDomain: string;

	constructor(cookieName: string, cookieDomain: string) {
		this._cookieName = cookieName;
		this._cookieDomain = cookieDomain;
	}

	// Tested
	public getCurrentCookieValue() {
		return this.Cookies.getJSON(this._cookieName);
	}

	// Tested
	public setInitialCookie(): void {
		const defaultCookie: ICookiePreferences = {
			performance: true,
			personalisation: true,
		}
		this.Cookies.set(this._cookieName, defaultCookie, this.getCookieSettings());
	}

	// Tested
	public setCookieSettings(performance: boolean, personalisation: boolean): void {
		const preferredCookieSettings: ICookiePreferences = {
			performance: performance,
			personalisation: personalisation,
		}
		this.Cookies.set(this._cookieName, preferredCookieSettings, this.getCookieSettings());
	}

	private getCookieSettings() {
		return { domain: this._cookieDomain, expires: 365 };
	}
}
